/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Документ
 */
export interface Document {
  /**
   * Идентификатор документа
   * @format uuid
   */
  id?: string;

  /** Тип документа */
  documentType?: string;
}

/**
 * Выгрузка файла
 */
export interface DocumentFile {
  /**
   * Идентификатор выгрузки
   * @format uuid
   */
  id?: string;

  /** Статус выгрузки */
  state?: string;

  /**
   * Дата создания файла
   * @format date-time
   */
  createDate?: string;

  /** Файл */
  bytes?: string;
}

/**
 * Ошибка на стороне сервиса
 */
export interface GenericError {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

export interface ErrorMessage {
  /** @format uuid */
  id?: string;
  message?: string;
}

/**
 * Количество удаленных и не удаленных документов
 */
export interface Delete {
  /**
   * Количество удаленных документов
   * @format int32
   */
  deletedCount?: number;

  /**
   * Количество документов, которые не удалось удалить
   * @format int32
   */
  failedCount?: number;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-group-operations
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-group-operations.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Массовые действия
     * @name massPrintForm
     * @summary Формирование файла массовой печати
     * @request POST:/api/group-operations/v1/external/mass/print-form
     * @secure
     */
    massPrintForm: (data: Document[], params: RequestParams = {}) =>
      this.request<DocumentFile, GenericError>({
        path: `/api/group-operations/v1/external/mass/print-form`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Массовые действия
     * @name massExportGet
     * @summary Получение файла массового экспорта
     * @request POST:/api/group-operations/v1/external/mass/export-get
     * @secure
     */
    massExportGet: (query: { exportId: string }, params: RequestParams = {}) =>
      this.request<File, GenericError>({
        path: `/api/group-operations/v1/external/mass/export-get`,
        method: "POST",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Массовые действия
     * @name massExportForm
     * @summary Формирование файла массового экспорта
     * @request POST:/api/group-operations/v1/external/mass/export-form
     * @secure
     */
    massExportForm: (data: Document[], params: RequestParams = {}) =>
      this.request<DocumentFile, ErrorMessage>({
        path: `/api/group-operations/v1/external/mass/export-form`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Массовые действия
     * @name massDelete
     * @summary Массовое удаление
     * @request POST:/api/group-operations/v1/external/mass/delete
     * @secure
     */
    massDelete: (data: Document[], params: RequestParams = {}) =>
      this.request<Delete, GenericError>({
        path: `/api/group-operations/v1/external/mass/delete`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Массовые действия
     * @name massPrintGet
     * @summary Получение файла массовой печати
     * @request GET:/api/group-operations/v1/external/mass/print-get
     * @secure
     */
    massPrintGet: (query: { exportId: string }, params: RequestParams = {}) =>
      this.request<File, GenericError>({
        path: `/api/group-operations/v1/external/mass/print-get`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
}

export const api = new Api();
